export const SafeAreaTopSpacer = () => <div className='safe-area-top' />
